import i18n from "@/i18n";

export const BRAND = {
  name: "Vale",
  hashtag: "#NeuroSpicy",
  motto: "Show your whole spectrum.",
  mottoTwo: "Neuro spicy, and proud of the flavour.",
  peacock: "https://static.prod-images.emergentagent.com/jobs/75f560b4-6ae5-477e-9e55-09f645718d99/images/42bc713ab0aa272a2aa6f987deafa0c434c5a023572c340cc0d0ac31c5f5a40d.jpeg",
  spicy: "https://static.prod-images.emergentagent.com/jobs/75f560b4-6ae5-477e-9e55-09f645718d99/images/e090ba20c108c7887d74ea8b242c9f72221b1c8c3313bee7ce717472f4dd79a8.jpeg",
};

// Peacock tail / neurodiversity colour wheel
export const SPECTRUM = ["#E4572E", "#F09D3C", "#F2C744", "#5FA85B", "#2F9E9E", "#2E6FB7", "#4B3F9E", "#8B4A9C"];

export const Peacock = ({ size = 34, className = "" }) => (
  <img src={BRAND.peacock} alt={i18n.t("brand.logoAlt")} width={size} height={size}
    className={`rounded-lg object-cover ${className}`} data-testid="peacock-logo" />
);

export const SpectrumBar = ({ className = "" }) => (
  <div className={`flex h-1.5 w-full overflow-hidden rounded-full ${className}`} data-testid="spectrum-bar">
    {SPECTRUM.map((c) => (
      <span key={c} className="flex-1" style={{ background: c }} />
    ))}
  </div>
);

export const Hashtag = ({ className = "" }) => (
  <span dir="ltr" className={`font-display tracking-tight ${className}`} data-testid="brand-hashtag">
    <span className="text-[var(--focus)]">#</span>NeuroSpicy
  </span>
);
